(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cif-2-json", [], factory);
	else if(typeof exports === 'object')
		exports["cif-2-json"] = factory();
	else
		root["cif-2-json"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 